"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
const inversify_1 = require("inversify");
const ServiceIdentifiers_1 = require("../../container/ServiceIdentifiers");
const Initializable_1 = require("../../decorators/Initializable");
const NoCustomNodes_1 = require("../../options/presets/NoCustomNodes");
const SelfDefendingTemplate_1 = require("../../templates/string-array-nodes/string-array-rotate-function-node/SelfDefendingTemplate");
const StringArrayRotateFunctionTemplate_1 = require("../../templates/string-array-nodes/string-array-rotate-function-node/StringArrayRotateFunctionTemplate");
const AbstractCustomNode_1 = require("../AbstractCustomNode");
const JavaScriptObfuscatorFacade_1 = require("../../JavaScriptObfuscatorFacade");
const NodeUtils_1 = require("../../node/NodeUtils");
const NumberUtils_1 = require("../../utils/NumberUtils");
let StringArrayRotateFunctionNode = class StringArrayRotateFunctionNode extends AbstractCustomNode_1.AbstractCustomNode {
    constructor(identifierNamesGeneratorFactory, customNodeFormatter, randomGenerator, options, escapeSequenceEncoder) {
        super(identifierNamesGeneratorFactory, customNodeFormatter, randomGenerator, options);
        this.escapeSequenceEncoder = escapeSequenceEncoder;
    }
    initialize(stringArrayName, stringArrayRotationAmount) {
        this.stringArrayName = stringArrayName;
        this.stringArrayRotationAmount = stringArrayRotationAmount;
    }
    getNodeStructure(nodeTemplate) {
        return NodeUtils_1.NodeUtils.convertCodeToStructure(nodeTemplate);
    }
    getNodeTemplate() {
        const timesName = this.identifierNamesGenerator.generate();
        const whileFunctionName = this.identifierNamesGenerator.generate();
        let code = '';
        if (this.options.selfDefending) {
            code = this.customNodeFormatter.formatTemplate(SelfDefendingTemplate_1.SelfDefendingTemplate(this.escapeSequenceEncoder), {
                timesName,
                whileFunctionName
            });
        }
        else {
            code = `${whileFunctionName}(++${timesName})`;
        }
        return JavaScriptObfuscatorFacade_1.JavaScriptObfuscator.obfuscate(this.customNodeFormatter.formatTemplate(StringArrayRotateFunctionTemplate_1.StringArrayRotateFunctionTemplate(), {
            code,
            timesName,
            stringArrayName: this.stringArrayName,
            stringArrayRotationAmount: NumberUtils_1.NumberUtils.toHex(this.stringArrayRotationAmount),
            whileFunctionName
        }), Object.assign(Object.assign({}, NoCustomNodes_1.NO_ADDITIONAL_NODES_PRESET), { identifierNamesGenerator: this.options.identifierNamesGenerator, identifiersDictionary: this.options.identifiersDictionary, seed: this.randomGenerator.getRawSeed() })).getObfuscatedCode();
    }
};
__decorate([
    Initializable_1.initializable(),
    __metadata("design:type", String)
], StringArrayRotateFunctionNode.prototype, "stringArrayName", void 0);
__decorate([
    Initializable_1.initializable(),
    __metadata("design:type", Number)
], StringArrayRotateFunctionNode.prototype, "stringArrayRotationAmount", void 0);
StringArrayRotateFunctionNode = __decorate([
    inversify_1.injectable(),
    __param(0, inversify_1.inject(ServiceIdentifiers_1.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
    __param(1, inversify_1.inject(ServiceIdentifiers_1.ServiceIdentifiers.ICustomNodeFormatter)),
    __param(2, inversify_1.inject(ServiceIdentifiers_1.ServiceIdentifiers.IRandomGenerator)),
    __param(3, inversify_1.inject(ServiceIdentifiers_1.ServiceIdentifiers.IOptions)),
    __param(4, inversify_1.inject(ServiceIdentifiers_1.ServiceIdentifiers.IEscapeSequenceEncoder)),
    __metadata("design:paramtypes", [Function, Object, Object, Object, Object])
], StringArrayRotateFunctionNode);
exports.StringArrayRotateFunctionNode = StringArrayRotateFunctionNode;
